import {fetchOrderDetails, fetchOrderDetailsSuccess, fetchStoreTimeSlots, fetchStoreTimeSlotsSuccess, modifyOrderDetails} from "redux/actions"
import {useDispatch, useSelector} from "react-redux"

import {useApiDefaults} from "./useApiDefaults"
import { processStoreTimeSlots } from "./useStoreTimeSlots"
import {useGetCustomerAddressList} from "./useGetCustomerAddressList"
import axios from 'config/axios'
import { CUSTOMER_TIMEZONE } from 'config/constant'
import { contactType } from 'routes/checkoutTheme2/CheckoutInfoTheme2/CheckoutInformationTheme2'
import { useQuery } from '@tanstack/react-query'

export default function useOrderDetails() {
  const orderId = useSelector(({ checkout }) => checkout.modifyOrderId);

  const dispatch = useDispatch()
  const apiDefaults = useApiDefaults()
  useGetCustomerAddressList()

  const {
    data: orderDetails = {},
    isLoading: orderDetailsLoading,
  } = useQuery({
    queryKey: ['orderDetails', orderId, apiDefaults],
    queryFn: fetchData,
    enabled: Boolean(orderId && orderId !== "0"),
  })

  async function fetchData() {
    async function getTimeSlots() {
      try {
        const body = {
          ...apiDefaults,
          timezone: CUSTOMER_TIMEZONE,
        };

        const url = "/AogGetStoreTimeSlots"
        const res = await axios.post(url, body)
        return res.data.data
      } catch (error) {
        console.log('❌ ERROR getting store time slots', error)
        return []
      }
    }

    async function getOrderInfo() {
      try {
        const body = {
          ...apiDefaults,
          order_id: orderId,
        }
        const res = await axios.post("/AogGetMyOrderDetails", body)
        return res.data.data
      } catch (error) {
        console.log('❌ ERROR getting order details', error)
        return []
      }
    }

    dispatch(fetchStoreTimeSlots());
    dispatch(fetchOrderDetails());

    const [timeSlots, orderDetails] = await Promise.all([getTimeSlots(), getOrderInfo()])
    dispatch(fetchStoreTimeSlotsSuccess(timeSlots));
    dispatch(fetchOrderDetailsSuccess(orderDetails));

    const dateTimeOptions = processStoreTimeSlots(timeSlots, orderDetails?.shipping_method)
    const formattedShippingDate = convertDate(orderDetails?.shipping_date)
    let checkoutTimeSlot = dateTimeOptions.find(
      i =>
        i.value.shipping_date === formattedShippingDate &&
        i.value.shipping_time === orderDetails?.shipping_time
    )
    if (!checkoutTimeSlot && dateTimeOptions?.length > 0) {
      checkoutTimeSlot = dateTimeOptions[0]
    }

    const checkoutContactType = orderDetails?.question_reply_contact_method ?? ""
    dispatch(
      modifyOrderDetails({
        checkoutStoreType: orderDetails?.shipping_method,
        checkoutTimeSlot: checkoutTimeSlot?.value,
        checkoutTimeSlotName: checkoutTimeSlot?.title,
        checkoutInstruction: orderDetails?.order_note ?? "",
        checkoutContactType,
        checkoutContactTypeLabel: contactType.find(i => i.value === checkoutContactType)?.title ?? "",
        checkoutContact:
          orderDetails?.order_perferred_mobile_number ?? "",
        customerAddress: orderDetails?.shipping_address_id ?? "",
        isTaxExempt: orderDetails?.is_apply_tax_exemption_on_this_order === "1" ? true : false,
      })
    )

    return orderDetails

  }

  return {
    orderdetailsData: orderDetails,
    orderdetailsDataLoading: orderDetailsLoading,
  }
}

function convertDate(date) {
  const [month, day, year] = date.split("-")
  const formatted = `${year}-${month}-${day}`
  return formatted
}
